import AuthFlowFrame from "../../components/AuthFlowFrame";
import { Content } from "@jobber/components/Content";
import { Text } from "@jobber/components/Text";
import { Link } from "@jobber/components/Link";
import { useEffect, useState } from "react";
import { jobberRedirectUrl } from "../../services";
import { AuthFlowButton } from "../../types";
import {showError} from "../../helpers";

function Step1() {
    const [buttonLink, setButtonLink] = useState("");
    useEffect(() => {
        (async () => {
            try {
                const state = sessionStorage.getItem('state');
                const {data: buttonLink} = await jobberRedirectUrl(state);
                setButtonLink(buttonLink.redirect_url);
            } catch(e: any) {
                showError("Error establishing connection with Jobber: " + e.message);
            }
        })();
    }, []);

    const button: AuthFlowButton = {
        link: buttonLink,
        text: "Connect to Jobber",
        type: "primary",
        disabled: false,
        loading: false,
    }

    return (
        <AuthFlowFrame
            pretitle={"Let's get you set up"}
            title={"Connect to Jobber"}
            step={1}
            totalSteps={3}
            button={button}
        >
            <Content type={"div"} spacing={"base"}>
                <Text size={"large"}>
                    After connecting your Jobber account, your integration will be ready to go!
                </Text>
                <Text size={"base"} variation={"subdued"}>
                    If you don’t have a Jobber account, <Link url={"https://getjobber.com/plp/xero/"} external={true}>create
                    a Jobber account</Link> and then come back to this tab to finish setting up your integration.
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step1;
